import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Store } from "@ngxs/store";
import { LoadFeatures } from "src/store/features/actions/set-features.action";
import { Features } from "src/app/services/response-models/features.response.model";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class FeaturesService {
    private readonly featuresUrl: string = `${environment.apiBaseUrl}features`;

    constructor(
        private http: HttpClient,
        private store: Store
    ) {}

    public async getFeatures(): Promise<Features> {
        const { data } = await lastValueFrom(this.http.get<Features>(this.featuresUrl));
        this.store.dispatch(new LoadFeatures(data));

        return { data } as Features;
    }
}
